<template>
  <div
    :class="[
      'BaseLoader',
      ('BaseLoader-' + color),
      ('BaseLoader-' + size),
      { 'BaseLoader-float': float }
    ]">
  </div>
</template>

<script>
export default {
  name: 'BaseLoader',

  props: {
    color: { type: String, default: 'dark' },
    size:  { type: String, default: 'small' },
    float: { type: Boolean, default: false },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_variables';

$size-small: 20px;
$size-large: 40px;

$border-small: 2px;
$border-large: 4px;

.BaseLoader {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  height: $size-small;
  width: $size-small;
  border-radius: 50%;
  border-width: $border-small;
  border-style: solid;
  border-color: $grey;
  border-top-color: $dark;
  animation: spin .5s cubic-bezier(0.560, 0.110, 0.220, 0.865) 0s infinite;

  @keyframes spin {
    from  { transform: rotate(45deg); }
    to    { transform: rotate(405deg); }
  }
}

.BaseLoader-white {
  border-color: rgba($white, .2);
  border-top-color: $white;
}

.BaseLoader-blue {
  border-top-color: $light-blue;
}

.BaseLoader-green {
  border-top-color: $green;
}

.BaseLoader-red {
  border-top-color: $red;
}

.BaseLoader-large {
  height: $size-large;
  width: $size-large;
  border-width: $border-large;
}

.BaseLoader-float {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  margin: auto;
}
</style>
